// extracted by mini-css-extract-plugin
export default {"wrap":"qH-z","subtitle":"rH-z","contentWrap":"sH-z","imgWrap":"tH-z","heading":"uH-z","copy":"vH-z"};